import React, { FC, useState } from 'react';
import styled from '@emotion/styled';
import gql from 'graphql-tag';
import { useTableUniverse } from '~Components/TableUniverse';
import { insideWrapperStyles } from '~ComponentsImproved/Modal';
import { useI18n, useSelector } from '~Hooks';
import { Box } from '~Styles';
import Grid from '~Scenes/Tables/Scenes/Grid';
import Floorplan from '~Scenes/Tables/Scenes/Floorplan';
import { Content } from '~Scenes/Tables';

const Wrapper = styled(Box)`
  height: 100%;
`;

const ModalWrapper = styled(Box)`
  box-shadow: ${insideWrapperStyles.boxShadow};
  border-radius: ${insideWrapperStyles.borderRadius};
  background-color: ${insideWrapperStyles.backgroundColor};
  height: 80vh;
  width: 90vw;
`;

const ViewTypesWrapper = styled.div`
  background-color: var(--colorBlueGray1100);
  width: 176px;
  display: flex;
  flex-flow: column nowrap;
`;

const ViewType = styled.div<{
  selected: boolean;
}>`
  height: 64px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.24px;
  color: var(--colorWhite);
  padding: 8px 12px 8px 8px;
  border-left: 4px solid transparent;
  border-left-color: ${(props) => (props.selected ? 'var(--colorUIYellow)' : 'transparent')};
  border-bottom: 1px solid var(--colorBlueGray1200);
  background: ${(props) =>
    props.selected
      ? 'linear-gradient(90deg, rgb(14, 18, 22) 0%, rgb(28, 35, 44) 100%)'
      : 'var(--colorBlueGray1100)'};
`;

interface Props {
  onSelectTable: (tableId: string) => void;
}

const TabletTables: FC<Props> = ({ onSelectTable }) => {
  const { i18n } = useI18n();
  const tableUniverse = useTableUniverse();
  const allCheques = tableUniverse.cheques;

  const floorPlans = useSelector((state) => state.floorPlans);

  const [selectedNav, setSelectedNav] = useState<string>('grid');
  const [selectedTableId, setSelectedTableId] = useState<string | undefined>(undefined);

  const handleSelectTable = (id: string) => {
    setSelectedTableId(id);
    onSelectTable(id);
  };

  return (
    <ModalWrapper>
      <Wrapper display="flex">
        <ViewTypesWrapper>
          <ViewType selected={selectedNav === 'grid'} onTouchStart={() => setSelectedNav('grid')}>
            {i18n('TM.Grid')}
          </ViewType>
          {floorPlans.map((floorPlan) => (
            <ViewType
              key={floorPlan.id}
              selected={selectedNav === floorPlan.id}
              onTouchStart={() => setSelectedNav(floorPlan.id)}>
              {floorPlan.name}
            </ViewType>
          ))}
        </ViewTypesWrapper>

        <Content>
          {selectedNav === 'grid' ? (
            <Grid
              allCheques={allCheques}
              selectedTable={selectedTableId}
              showOnlyOpen={false}
              setSelectedTable={handleSelectTable}
            />
          ) : (
            selectedNav.length > 0 && (
              <Floorplan
                selectedFloorPlan={selectedNav}
                allCheques={allCheques}
                selectedTable={selectedTableId}
                setSelectedTable={handleSelectTable}
              />
            )
          )}
        </Content>
      </Wrapper>
    </ModalWrapper>
  );
};

export default TabletTables;
